import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import About from '@/components/About';
import Team from '@/components/Team';
import Contact from '@/components/Contact';
import Projects from '@/components/Projects';
import Blog from '@/components/Blog';

Vue.use(Router);

export default new Router({
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/about', name: 'about', component: About },
    { path: '/projects', name: 'projects', component: Projects },
    { path: '/team', name: 'team', component: Team },
    { path: '/blog', name: 'blog', component: Blog },
    { path: '/contact', name: 'contact', component: Contact },
    { path: '*', redirect: { name: 'home' } },
  ],
});